<template>
  <div class="section-title-block">
    <h2 class="section-title">
      {{ props.title }}
    </h2>
  </div>
</template>

<script setup lang="ts">
  import type { RouterLinkProps } from 'vue-router';

  interface Props {
    title: string;
    to?: RouterLinkProps['to'];
    href?: string;
  }

  const props = defineProps<Props>();
</script>

<style lang="scss" scoped>
  @use '@experience/design-tokens/typography' as typography;
  @use '@experience/shared/dist/assets/adaptivity' as adaptivity;

  .section-title-block {
    display: flex;
    align-items: baseline;
  }

  .section-title {
    margin-bottom: 24px;

    @include typography.base-800-750-extra;

    @include adaptivity.mobile {
      margin-bottom: 16px;

      @include typography.base-700-500-extra;
    }
  }
</style>
